import { Plan, Price } from '@smarty-nx/data'

// Shape returned by an `allApiPlan { nodes { ... } }` GraphQL query against
// the `ApiPlan` nodes created by the gatsby-source-api-plans plugin (which
// sources base/non-voucher pricing from /v3/plans at build time). Mirrors
// the fields of `Plan` (@smarty-nx/data) that the plugin queries are
// expected to select — keep in sync with the `allApiPlan` query fragments
// used by each consuming component.
//
// Note: `apiId` (not `id`) holds the API's own plan identifier (e.g.
// 'SM_EVERYONE_UNLIMITED') — Gatsby reserves the top-level `id` field on
// every sourced node for its own node ID, so the plugin can't also use it
// for the API's id without one silently overwriting the other.
export interface ApiPlanNode {
  slug: string
  apiId: string
  name: string
  description: string
  finalPrice: Price
  finalPriceWithoutCredit: Price
  originalPrice: Price
  dataAllowanceGB: number | null
  planIsDataOnly: boolean | null
  planIsSocialTariff: boolean | null
  additionalSims?: Price | null
  style?: {
    planColor?: string
    planColorPale?: string
  }
}

// `matchPlanMeta` (apps/marketing/src/utils/plans.ts) is the single merge
// point between API plan data and Contentful plan metadata, and is reused
// unchanged here — this mapper only needs to fill in the fields that the
// build-time source plugin never has (voucher pricing is exclusively a
// client-side, post-hydration concern, see usePlansWithFallback).
export const mapApiPlanNodesToPlans = (nodes: readonly ApiPlanNode[]): Plan[] =>
  nodes.map(
    ({ apiId, ...node }) =>
      ({
        ...node,
        id: apiId,
        voucher: null,
      } as unknown as Plan)
  )
